import { z } from 'zod'
import { emailSchema } from '../validators/email.validator.js'
import { passwordSchema } from '../validators/password.validator.js'

/**
 * Body for `POST /invites` — invite someone to join. The email is trimmed and
 * lowercased by the shared `emailSchema` so the same address can't be invited
 * twice under different casing.
 */
export const createInviteInputSchema = z
  .object({
    email: emailSchema,
  })
  .strict()

export type CreateInviteInput = z.infer<typeof createInviteInputSchema>

/**
 * Body for `POST /invites/accept/:token` — claim an invite by setting a name
 * and password. The email is NOT accepted here: it comes from the invite the
 * token resolves to, so a token holder cannot redirect the invite to a
 * different address.
 */
export const acceptInviteInputSchema = z
  .object({
    name: z.string().trim().min(1, 'Name is required').max(120),
    password: passwordSchema,
  })
  .strict()

export type AcceptInviteInput = z.infer<typeof acceptInviteInputSchema>
